import { render, staticRenderFns } from "./BadGateway.vue?vue&type=template&id=02e85721"
import script from "./BadGateway.vue?vue&type=script&lang=ts"
export * from "./BadGateway.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports